import React, { useEffect, useState, useRef } from "react";
import {
    Typography,
    Button,
    Input,
    IconButton,
    Tooltip
} from "@material-tailwind/react";
import Swal from "sweetalert2";
import Toaster from "../../components/Toaster";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Popover } from 'react-tiny-popover';
import ShowLoader from "@/components/Loader";
import useHasPermission from "../../components/useHasPermission";
import {
    Bars3BottomLeftIcon,
    ChevronDownIcon,
    MagnifyingGlassIcon,
    XCircleIcon,
    InformationCircleIcon,
    ClockIcon,
    ChatBubbleOvalLeftEllipsisIcon,
    DocumentArrowDownIcon,
    FunnelIcon,
    CalendarDaysIcon,
} from "@heroicons/react/24/solid";
import ScrollToTop from "@/components/ScrollToTop";
import { AssignCRManagerModal } from "./order-modals/assign-order-to-cr-modal";
import TimeLineModal from "./order-modals/timeline-modal";
import moment from "moment";
import InfiniteScroll from 'react-infinite-scroll-component';
import { approveOrderByFinance, updateCancellationStatus, clearOrders, deleteOrders, getOrderCount, getOrders, setEmptyCRTeamMember, rejectOrderDueToPaymentIssue, sendBackToFinance, revertFinanceApproval } from "@/store/slices/orderSlice";
import DocumentViewModal from "@/components/DocumentViewModal";
import { useTranslation } from "react-i18next";
import ViewAssignedMembers from "./order-modals/view-assigned-members";
let action_options = [];

export function Order() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { t } = useTranslation('order');
    const { t: ct } = useTranslation('common');

    // Selectors
    const { user } = useSelector((state) => state.user);
    const { list_orders, loading, list_loading, hasMore, total_count, order_counts, unread_counts, unread_type_counts } = useSelector((state) => state.order);

    const hasUnreadNormal = Number(unread_type_counts?.normal) > 0;
    const hasUnreadCustom = Number(unread_type_counts?.custom) > 0;

    // State
    const [search, setSearch] = useState('');
    const [sortingOrder, setSortingOrder] = useState('');
    const [isSortingPopoverOpen, setIsSortingPopoverOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [activeTab, setActiveTab] = useState("normal");
    const [isCheckedItemPopoverOpen, setIsCheckedItemPopoverOpen] = useState(false);
    const [isTimelineModalOpen, setIsTimelineModalOpen] = useState(false);
    const [checkedAction, setCheckedAction] = useState('');
    const [checkedItems, setCheckedItems] = useState([]);
    const [statusFilter, setStatusFilter] = useState('');
    const [filter, setFilter] = useState(null);
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [isSpinning1, setIsSpinning1] = useState(false);
    const [isSpinning2, setIsSpinning2] = useState(false);
    const [isSetPOFile, setPOFile] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [isMemberShow, setIsMemberShow] = useState(false);
    const [isFilterPopoverOpen, setIsFilterPopoverOpen] = useState(false);
    const [orderTypeFilter, setOrderTypeFilter] = useState('');

    const hasUpdatePermission = useHasPermission(`order.update`);
    const hasDeletePermission = useHasPermission(`order.delete`);

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const [tabs, setTabs] = useState([]);
    const [isStatusPopoverOpen, setIsStatusPopoverOpen] = useState(false);

    const sorting_options = [
        { label: t('sort_ascending'), value: 'asc' },
        { label: t('sort_descending'), value: 'desc' },
    ];

    useEffect(() => {
        dispatch(getOrderCount());
    }, [])

    const loadData = (pageNumber = 1, isAppend = false) => {
        dispatch(getOrders({
            activetab: activeTab,
            page: pageNumber,
            perPage: itemsPerPage,
            search: search,
            filter: filter,
            sort_order: sortingOrder,
            status: statusFilter,
            dashboard_key: orderTypeFilter,
            start_date: startDate,
            end_date: endDate
        }));
    };


    useEffect(() => {
        if (!user) return;
        action_options = [];

        // if (hasDeletePermission) {
        //     action_options = [{ label: 'Delete', value: 'delete' }];
        // }
        const role = user?.roles?.[0];
        const currentFilter = searchParams.get("filter");

        if (hasDeletePermission) {
            action_options = [
                {
                    label: t('delete_action'),
                    value: 'delete',
                    disabled: role === "City Representative"
                }
            ];

            if (
                currentFilter === "unassigned" &&
                ["Administrator", "Sub Admin"].includes(role)
            ) {
                action_options.push({
                    label: t('send_back_to_finance'),
                    value: 'send_back_to_finance',
                    disabled: false
                });
            }
        }

        let newTabs = [];
        let defaultFilter = "";

        if (role === "City Representative" || role === "Procurement") {
            newTabs = [{ id: "assigned", label: t('assigned_tab') }, { id: "reassigned_order", label: t('reassigned_tab') }];
            defaultFilter = "assigned";
        } else if (role === "Finance") {
            newTabs = [
                { id: "pending_for_approval", label: t('approval_pending_tab') },
                { id: "payment_issue", label: t('payment_issue_tab') },
                { id: "approved_from_finance", label: t('approved_from_finance_tab') },
                { id: "reassigned_order", label: t('reassigned_tab') },
                { id: "cancelled", label: t('cancelled_tab') }
            ];
            defaultFilter = "pending_for_approval";
        } else if (role === "Sales Representative") {
            newTabs = [
                { id: "unassigned", label: t('unassigned_tab') },
                { id: "assigned", label: t('assigned_tab') },
                { id: "reassigned_order", label: t('reassigned_tab') }
            ];
            defaultFilter = "unassigned";
        } else {
            newTabs = [
                { id: "pending_for_approval", label: t('finance_approval_pending_tab') },
                { id: "payment_issue", label: t('payment_issue_tab') },
                { id: "unassigned", label: t('unassigned_tab') },
                { id: "assigned", label: t('assigned_tab') },
                { id: "reassigned_order", label: t('reassigned_tab') },
                { id: "cancelled", label: t('cancelled_tab') }
            ];
            defaultFilter = "pending_for_approval";
        }

        const filter = searchParams.get("filter");
        const active_tab = searchParams.get("activeTab");

        setTabs(newTabs);
        const isValidFilter = newTabs.some(t => t.id === filter);
        setFilter(isValidFilter ? filter : defaultFilter);
        setActiveTab(active_tab || 'normal');
    }, [user, hasDeletePermission, searchParams]);

    useEffect(() => {
        if (!filter) return;

        setCurrentPage(1);
        setCheckedItems([]);

        dispatch(clearOrders());
        let params = {};
        params.filter = filter;
        params.activeTab = activeTab;
        setSearchParams(params, { replace: true });
        loadData(1);

    }, [activeTab, filter, sortingOrder, statusFilter, orderTypeFilter, startDate, endDate]);


    // Handlers
    const handelSearch = (event) => {
        if (event.key === "Enter") {
            setCurrentPage(1);
            loadData(1);
        } else if (event.key === "Backspace" && search.length === 0) {
            setCurrentPage(1);
            loadData(1);
        }
    };

    const handleSearchClick = () => {
        setCurrentPage(1);
        loadData(1);
    };

    const handelRemoveSearch = () => {
        setSearch('');
        setCurrentPage(1);
        dispatch(getOrders({
            activetab: activeTab, page: 1, perPage: itemsPerPage, search: '', filter, sort_order: sortingOrder, status: statusFilter,
            dashboard_key: orderTypeFilter
        }));
    };

    const handelSorting = (value) => {
        setSortingOrder(value);
        setIsSortingPopoverOpen(false);
    };

    const fetchMoreData = () => {
        if (!list_loading && hasMore) {
            const nextPage = currentPage + 1;
            dispatch(getOrders({
                activetab: activeTab,
                page: nextPage,
                perPage: itemsPerPage,
                search: search,
                filter: filter,
                sort_order: sortingOrder,
                status: statusFilter,
                dashboard_key: orderTypeFilter
            })).unwrap().then(() => {
                setCurrentPage(nextPage);
            }).catch(() => {
                // Handle error silently or show toast
            });
        }
    };

    const forceReloadOrder = () => {
        setIsSpinning1(true);
        setSearch('');
        setCurrentPage(1);
        dispatch(getOrders({
            activetab: activeTab, page: 1, perPage: itemsPerPage, search: '', filter, sort_order: '', status: '',
            dashboard_key: orderTypeFilter
        }))
            .finally(() => setTimeout(() => setIsSpinning1(false), 1000));
    };

    const reloadOrder = () => {
        setIsSpinning2(true);
        loadData(currentPage);
        setTimeout(() => setIsSpinning2(false), 1000);
    };

    const handelCheckedItems = (action) => {
        setCheckedAction(action);
        setIsCheckedItemPopoverOpen(false);

        if (checkedItems.length === 0) {
            Toaster.error(t('select_items_first'));
            return;
        }

        if (action === 'send_back_to_finance') {
            Swal.fire({
                title: t('send_back_to_finance_title'),
                input: 'textarea',
                inputLabel: t('rejection_reason_label'),
                inputPlaceholder: t('rejection_reason_placeholder'),
                inputAttributes: {
                    'aria-label': t('rejection_reason_placeholder'),
                },
                showCancelButton: true,
                confirmButtonText: t('send_back_to_finance'),
                cancelButtonText: ct('cancel'),
                allowOutsideClick: false,

                inputValidator: (value) => {
                    if (!value || !value.trim()) {
                        return t('rejection_reason_required');
                    }

                    if (value.trim().length < 5) {
                        return t('rejection_reason_min');
                    }

                    if (value.trim().length > 250) {
                        return t('rejection_reason_max');
                    }
                },
            }).then((result) => {
                if (!result.isConfirmed) {
                    return;
                }

                dispatch(
                    revertFinanceApproval({
                        order_ids: checkedItems,
                        rejection_reason: result.value.trim(),
                    })
                )
                    .unwrap()
                    .then((res) => {
                        console.log("Revert Finance Response:", res);

                        Toaster.success(
                            res?.message || t('send_back_to_finance_success')
                        );

                        setCheckedItems([]);
                        setIsCheckedItemPopoverOpen(false);

                        loadData(1);
                        dispatch(getOrderCount());
                    })
                    .catch((error) => {
                        console.error('Revert finance approval failed:', error);

                        Toaster.error(
                            error?.message ||
                            error?.response?.data?.message ||
                            ct('actionFailed')
                        );
                    });
            });

            return;
        }

        if (action === 'delete') {
            Swal.fire({
                title: ct("areYouSure"),
                text: t("delete_order_confirmation"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: ct("yesDelete")
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(
                        deleteOrders({
                            order_ids: checkedItems
                        })
                    )
                        .unwrap()
                        .then(() => {
                            Toaster.success(
                                t('order_deleted_success')
                            );

                            setCheckedItems([]);
                            loadData(1);
                        })
                        .catch(() =>
                            Toaster.error(ct("actionFailed"))
                        );
                }
            });
        }
    };

    const handleSingleCheck = (id) => {
        setCheckedItems(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
    };

    const handleCheckAll = (e) => {
        if (e.target.checked) {
            setCheckedItems(list_orders?.map(row => row.id) || []);
        } else {
            setCheckedItems([]);
        }
    };

    const formatReceivedOrderDate = (dateStr) => {
        if (!dateStr) return "N/A";
        const date = moment(dateStr);
        return date.isSame(moment(), "day") ? `${t('today_date')} | ${date.format("h:mm A")}` : date.format("D MMM | h:mm A");
    };

    const isAllChecked = list_orders?.length > 0 && checkedItems.length === list_orders?.length;

    const financeApproveOrder = async (id) => {

        Swal.fire({
            title: t("financeApproval"),
            html: `
                <p style="color:#6b7280; font-size:14px; margin-bottom:16px;">
                    ${t("chooseActionForOrder")}
                </p>
                <div style="display:flex; flex-direction:column; gap:10px;">
                    <button id="fa-approve-btn" style="
                        display:flex; align-items:center; justify-content:center;
                        gap:8px; width:100%; padding:12px 16px; border-radius:8px;
                        background:#22c55e; color:#fff; font-weight:600; font-size:14px;
                        border:none; cursor:pointer; transition:background .2s;
                    " onmouseover="this.style.background='#16a34a'" onmouseout="this.style.background='#22c55e'">
                        ${t("approveAndSendToAdmin")}
                    </button>

                    <button id="fa-revert-btn" style="
                        display:flex; align-items:center; justify-content:center;
                        gap:8px; width:100%; padding:12px 16px; border-radius:8px;
                        background:#ef4444; color:#fff; font-weight:600; font-size:14px;
                        border:none; cursor:pointer; transition:background .2s;
                    " onmouseover="this.style.background='#dc2626'" onmouseout="this.style.background='#ef4444'">
                        ${t("revertToRfq")}
                    </button>

                    <button id="fa-payment-issue-btn" style="
                        display:flex; align-items:center; justify-content:center;
                        gap:8px; width:100%; padding:12px 16px; border-radius:8px;
                        background:#f97316; color:#fff; font-weight:600; font-size:14px;
                        border:none; cursor:pointer; transition:background .2s;
                    " onmouseover="this.style.background='#ea580c'" onmouseout="this.style.background='#f97316'">
                        ${t("rejectPaymentIssue")}
                    </button>
                </div>
            `,
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: t("close"),
            allowOutsideClick: false,
            buttonsStyling: false,
            customClass: {
                cancelButton:
                    "bg-gray-300 hover:bg-gray-400 text-black px-4 py-2 rounded mt-3",
            },
            didOpen: () => {
                const approveBtn = document.getElementById("fa-approve-btn");
                const revertBtn = document.getElementById("fa-revert-btn");
                const paymentIssueBtn = document.getElementById("fa-payment-issue-btn");

                /*
                |--------------------------------------------------------------------------
                | APPROVE ORDER
                |--------------------------------------------------------------------------
                */
                approveBtn?.addEventListener("click", () => {
                    Swal.close();

                    dispatch(
                        approveOrderByFinance({
                            order_id: id,
                            approval: 'yes'
                        })
                    )
                        .unwrap()
                        .then((res) => {
                            if (res?.status) {
                                Toaster.success(t("order_approved_success"));
                                loadData(1);
                            } else {
                                Toaster.error(res?.message);
                            }
                        })
                        .catch((error) => {
                            console.error("Changes failed:", error);
                            Toaster.error("Changes failed, please try again.");
                        });
                });

                /*
                |--------------------------------------------------------------------------
                | REJECT ORDER (Revert to RFQ)
                |--------------------------------------------------------------------------
                */
                revertBtn?.addEventListener("click", () => {
                    Swal.close();

                    Swal.fire({
                        title: t("finance_reject_title"),
                        input: "textarea",
                        inputLabel: t("rejection_reason_label"),
                        inputPlaceholder: t("enter_rejection_reason_placeholder"),
                        inputAttributes: {
                            "aria-label": "Enter rejection reason",
                        },
                        showCancelButton: true,
                        confirmButtonText: t("submit"),
                        cancelButtonText: t("cancel"),

                        inputValidator: (value) => {

                            if (!value) {
                                return t("rejection_reason_required");
                            }

                            if (value.trim().length < 5) {
                                return t("rejection_reason_min");
                            }

                            if (value.trim().length > 250) {
                                return t("rejection_reason_max");
                            }
                        },
                    }).then((reasonResult) => {

                        if (reasonResult.isConfirmed) {

                            dispatch(
                                approveOrderByFinance({
                                    order_id: id,
                                    approval: 'no',
                                    reason: reasonResult.value,
                                })
                            )
                                .unwrap()
                                .then((res) => {

                                    if (res?.status) {
                                        Toaster.success(t("order_rejected_reverted_rfq_successfully"));
                                        loadData(1);
                                    } else {
                                        Toaster.error(res?.message);
                                    }
                                })
                                .catch((error) => {
                                    console.error("Changes failed:", error);
                                    Toaster.error(
                                        error?.message || "Changes failed, please try again."
                                    );
                                });
                        }
                    });
                });

                /*
                |--------------------------------------------------------------------------
                | REJECT DUE TO PAYMENT ISSUE
                |--------------------------------------------------------------------------
                */
                paymentIssueBtn?.addEventListener("click", () => {
                    Swal.close();
                    openPaymentIssueReasonModal(id);
                });
            },
        });
    };

    /*
    |--------------------------------------------------------------------------
    | REJECT DUE TO PAYMENT ISSUE
    |--------------------------------------------------------------------------
    */
    const openPaymentIssueReasonModal = (id) => {

        Swal.fire({
            title: t("rejectPaymentIssue"),
            input: "textarea",
            inputLabel: t("payment_issue_reason"),
            inputPlaceholder: t("enter_payment_issue_reason"),
            inputAttributes: {
                "aria-label": "Enter payment issue reason",
            },
            showCancelButton: true,
            confirmButtonText: t("submit"),
            cancelButtonText: t("cancel"),

            inputValidator: (value) => {

                if (!value) {
                    return t("rejection_reason_required");
                }

                if (value.trim().length < 5) {
                    return t("rejection_reason_min");
                }

                if (value.trim().length > 250) {
                    return t("rejection_reason_max");
                }
            },
        }).then((reasonResult) => {

            if (reasonResult.isConfirmed) {

                dispatch(
                    rejectOrderDueToPaymentIssue({
                        order_id: id,
                        reason: reasonResult.value,
                    })
                )
                    .unwrap()
                    .then((res) => {

                        if (res?.status) {
                            Toaster.success(t("order_rejected_due_to_payment_issue_successfully"));
                            loadData(1);
                        } else {
                            Toaster.error(res?.message);
                        }
                    })
                    .catch((error) => {
                        console.error("Changes failed:", error);
                        Toaster.error(
                            error?.message || "Changes failed, please try again."
                        );
                    });
            }
        });
    };

    /*
|--------------------------------------------------------------------------
| RESEND TO FINANCE (from Payment Issue tab)
|--------------------------------------------------------------------------
*/
    /*
    |--------------------------------------------------------------------------
    | RESEND TO FINANCE (from Payment Issue tab)
    |--------------------------------------------------------------------------
    */
    const resendToFinance = (id) => {
        Swal.fire({
            title: "Resend to Finance",
            text: "Are you sure you want to send this order back to Finance?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Resend",
            cancelButtonText: "Cancel",
            buttonsStyling: false,
            customClass: {
                confirmButton:
                    "bg-[#F4B320] hover:bg-yellow-500 text-[#1A1918] px-4 py-2 rounded mr-2",
                cancelButton:
                    "bg-gray-300 hover:bg-gray-400 text-black px-4 py-2 rounded",
            },
        }).then((result) => {

            if (result.isConfirmed) {

                dispatch(
                    sendBackToFinance({
                        order_id: id,
                    })
                )
                    .unwrap()
                    .then((res) => {
                        if (res?.status) {
                            Toaster.success(t("order_sent_back_to_finance_successfully"));
                            loadData(1);
                        } else {
                            Toaster.error(res?.message);
                        }
                    })
                    .catch((error) => {
                        console.error("Changes failed:", error);
                        Toaster.error(
                            error?.message || "Changes failed, please try again."
                        );
                    });
            }
        });
    };

    const handleCancellationAction = (id) => {
        Swal.fire({
            title: t('cancellation_request_title'),
            text: t('cancellation_request_text'),
            icon: "warning",
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonText: t('approve_button'),
            denyButtonText: t('reject_button'),
            cancelButtonText: t('close_button'),
            allowOutsideClick: false,
            buttonsStyling: false,
            customClass: {
                confirmButton:
                    "bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded mr-2",
                denyButton:
                    "bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded mr-2",
                cancelButton:
                    "bg-gray-300 hover:bg-gray-400 text-black px-4 py-2 rounded",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                // ✅ APPROVE (no reason needed)
                dispatch(updateCancellationStatus({ id, type: "approve" }))
                    .unwrap()
                    .then(() => {
                        Toaster.success(t("order_cancelled_success"));
                        loadData(1);
                    })
                    .catch((error) =>
                        Toaster.error(
                            error?.message || "Something went wrong. Please try again."
                        )
                    );
            }

            if (result.isDenied) {
                // ✅ REJECT (ask for reason)
                Swal.fire({
                    title: "Reject Cancellation",
                    input: "textarea",
                    inputLabel: "Rejection Reason",
                    inputPlaceholder: "Enter rejection reason...",
                    inputAttributes: {
                        "aria-label": "Enter rejection reason",
                    },
                    showCancelButton: true,
                    confirmButtonText: "Submit",
                    cancelButtonText: "Cancel",
                    inputValidator: (value) => {
                        if (!value) {
                            return t("rejection_reason_required");
                        }
                        if (value.length < 10) {
                            return "Reject reason must be at least 10 characters";
                        }
                        if (value.length > 50) {
                            return "Reject reason should not be longer than 50 characters";
                        }
                    },
                }).then((reasonResult) => {
                    if (reasonResult.isConfirmed) {
                        dispatch(
                            updateCancellationStatus({
                                id,
                                type: "reject",
                                rejection_reason: reasonResult.value,
                            })
                        )
                            .unwrap()
                            .then(() => {
                                Toaster.success(
                                    (t("cancellation_rejected_success"))
                                );
                                loadData(1);
                            })
                            .catch((error) =>
                                Toaster.error(
                                    error?.message ||
                                    "Something went wrong. Please try again."
                                )
                            );
                    }
                });
            }
        });
    };

    const [openRemarkId, setOpenRemarkId] = useState(null);

    const getTimeSlotStatus = (toTime) => {
        if (!toTime) return { color: "text-gray-500", text: "N/A", delayed: "" };

        const now = moment();
        const end = moment(toTime);
        const isDelayed = now.isAfter(end);

        let delayedText = "";
        if (isDelayed) {
            const days = now.diff(end, 'days');
            const hours = now.diff(end, 'hours') % 24;

            if (days > 0) {
                delayedText = ` (${days} ${days === 1 ? t('day_delayed') : t('days_delayed')})`;
            } else if (hours > 0) {
                delayedText = ` (${hours} ${hours === 1 ? t('hour_delayed') : t('hours_delayed')})`;
            } else {
                delayedText = " (delayed)";
            }
        }

        return {
            color: isDelayed ? "text-red-500" : "text-green-500",
            delayed: delayedText
        };
    };

    const isPaymentFilterDisabled = ['pending_for_approval', 'payment_issue', 'cancelled'].includes(filter);

    const hidePurchasePending = ['pending_for_approval', 'payment_issue', 'cancelled'].includes(filter);

    return (
        <div className="mt-5 mb-8 flex flex-col gap-8">
            {loading && <ShowLoader />}
            <ScrollToTop />

            {/* Header Section */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 px-4 md:px-6">
                <div className="flex w-full md:flex-1 items-center">
                    <Typography variant="h5" color="blue-gray" className="font-bold text-xl capitalize">
                        {t('order_list_title')}
                    </Typography>
                    <button onClick={forceReloadOrder} className="ml-4">
                        <img src="/img/icons/reload.png" alt='Reload' className={`h-4 w-4 ${isSpinning1 ? "animate-spin" : ""}`} />
                    </button>
                </div>

                <div className="w-full md:flex-1 flex justify-center items-center gap-2">
                    <div className="w-full relative max-w-md">
                        <Input
                            label={ct("search")}
                            icon={!search && <MagnifyingGlassIcon className="h-5 w-5" />}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyUp={handelSearch}
                            className="pr-10"
                        />
                        {search && (
                            <IconButton variant="text" size="sm" className="!absolute right-1 top-1" onClick={handelRemoveSearch}>
                                <XCircleIcon className="h-5 w-5 text-red-500" />
                            </IconButton>
                        )}
                    </div>
                    {search && (
                        <Button
                            variant="outlined"
                            className="flex items-center border-gray-300 capitalize font-bold bg-black text-white whitespace-nowrap"
                            onClick={handleSearchClick}
                        >
                            {t('search_button')}
                        </Button>
                    )}
                </div>
            </div>

            <div className="mb-7 grid gap-y-3 gap-x-3 md:grid-cols-2 xl:grid-cols-6 px-4 md:px-6">

                <div className="border border-blue-gray-100 shadow-sm p-4 rounded-xl bg-white">
                    <Typography variant="h4" color="blue-gray">
                        {order_counts?.total_orders ?? 0}
                    </Typography>
                    <Typography variant="small" className="font-normal text-blue-gray-600 mt-2 capitalize">
                        {t('total_orders_label')}
                    </Typography>
                </div>
                <div className="border border-blue-gray-100 shadow-sm p-4 rounded-xl bg-white">
                    <Typography variant="h4" color="blue-gray">
                        {order_counts?.new_orders ?? 0}
                    </Typography>
                    <Typography variant="small" className="font-normal text-blue-gray-600 mt-2 capitalize">
                        {t('new_orders_label')}
                    </Typography>
                </div>
                <div className="border border-blue-gray-100 shadow-sm p-4 rounded-xl bg-white">
                    <Typography variant="h4" color="blue-gray">
                        {order_counts?.delayed_orders ?? 0}
                    </Typography>
                    <Typography variant="small" className="font-normal text-blue-gray-600 mt-2 capitalize">
                        {t('delayed_orders_label')}
                    </Typography>
                </div>
                <div className="border border-blue-gray-100 shadow-sm p-4 rounded-xl bg-white">
                    <Typography variant="h4" color="blue-gray">
                        {order_counts?.completed_orders ?? 0}
                    </Typography>
                    <Typography variant="small" className="font-normal text-blue-gray-600 mt-2 capitalize">
                        {t('completed_orders_label')}
                    </Typography>
                </div>
                <div className="border border-blue-gray-100 shadow-sm p-4 rounded-xl bg-white">
                    <Typography variant="h4" color="blue-gray">
                        {order_counts?.cancelled_orders ?? 0}
                    </Typography>
                    <Typography variant="small" className="font-normal text-blue-gray-600 mt-2 capitalize">
                        {t('cancelled_orders_label')}
                    </Typography>
                </div>
                <div className="border border-blue-gray-100 shadow-sm p-4 rounded-xl bg-white">
                    <Typography variant="h4" color="blue-gray">
                        {order_counts?.refund_requests ?? 0}
                    </Typography>
                    <Typography variant="small" className="font-normal text-blue-gray-600 mt-2 capitalize">
                        {t('refund_requests_label')}
                    </Typography>
                </div>
            </div>

            {/* Tab Toggle (Normal vs Custom) */}
            <div className="px-4 md:px-6">
                {/* <div className="flex bg-gray-100 w-fit rounded-2xl p-1 shadow-sm gap-2">
                    <button
                        onClick={() => setActiveTab("normal")}
                        className={`relative text-sm font-normal px-4 md:px-6 py-2 rounded-2xl transition-all duration-300 z-10 capitalize ${activeTab === "normal" ? "text-white bg-black" : "text-gray-700 hover:text-black"}`}
                    >
                        {t('normal_order_tab')}
                    </button>
                    <button
                        onClick={() => setActiveTab("custom")}
                        className={`relative text-sm font-normal px-4 md:px-6 py-2 rounded-2xl transition-all duration-300 z-10 capitalize ${activeTab === "custom" ? "text-white bg-black" : "text-gray-700 hover:text-black"}`}
                    >
                        {t('custom_order_tab')}
                    </button>
                </div> */}
                <div className="flex bg-gray-100 w-fit rounded-2xl p-1 shadow-sm gap-2">
                    <button
                        onClick={() => setActiveTab("normal")}
                        className={`relative text-sm font-normal px-4 md:px-6 py-2 rounded-2xl transition-all duration-300 z-10 capitalize ${activeTab === "normal" ? "text-white bg-black" : "text-gray-700 hover:text-black"}`}
                    >
                        <span className="relative inline-block">
                            {t('normal_order_tab')}
                            {hasUnreadNormal && (
                                <span className="absolute -top-1 -right-3 flex h-2 w-2">
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                    <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                                </span>
                            )}
                        </span>
                    </button>
                    <button
                        onClick={() => setActiveTab("custom")}
                        className={`relative text-sm font-normal px-4 md:px-6 py-2 rounded-2xl transition-all duration-300 z-10 capitalize ${activeTab === "custom" ? "text-white bg-black" : "text-gray-700 hover:text-black"}`}
                    >
                        <span className="relative inline-block">
                            {t('custom_order_tab')}
                            {hasUnreadCustom && (
                                <span className="absolute -top-1 -right-3 flex h-2 w-2">
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                    <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                                </span>
                            )}
                        </span>
                    </button>
                </div>
            </div>

            {/* Actions Bar */}
            <div className="flex flex-row justify-between items-center px-0 xl:px-6 w-full max-w-[1000px] xl:max-w-full overflow-x-auto">
                <div className="flex items-center gap-4 shrink-0 pr-2 xl:pr-0">
                    {hasDeletePermission && (
                        <input type="checkbox" className="w-4 h-4 accent-green cursor-pointer" onChange={handleCheckAll} checked={isAllChecked} />
                    )}
                    <button onClick={reloadOrder}>
                        <img src="/img/icons/reload.png" alt='Reload' className={`h-4 w-4 ${isSpinning2 ? "animate-spin" : ""}`} />
                    </button>
                </div>

                <div className="flex items-center gap-3">
                    {/* Date Range Filter */}
                    <div className="flex items-center gap-2 bg-[#EBE9E6] px-3 py-2 rounded-lg">
                        <CalendarDaysIcon className="h-5 w-5 text-gray-700" />
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            className="bg-transparent outline-none text-sm"
                        />
                        <span className="text-gray-500 text-sm">to</span>
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            className="bg-transparent outline-none text-sm"
                        />
                        {(startDate || endDate) && (
                            <XCircleIcon
                                className="h-5 w-5 text-red-500 cursor-pointer"
                                onClick={() => {
                                    setStartDate('');
                                    setEndDate('');
                                }}
                            />
                        )}
                    </div>
                    <Popover
                        isOpen={isSortingPopoverOpen}
                        positions={["bottom"]}
                        onClickOutside={() => setIsSortingPopoverOpen(false)}
                        content={
                            <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 py-1 border border-gray-100">
                                <button onClick={() => handelSorting("")} className={`text-left text-sm px-3 py-2 hover:bg-gray-100 capitalize ${sortingOrder === '' ? 'bg-gray-50' : ''}`}>{t('latest_sort')}</button>
                                {sorting_options.map((opt) => (
                                    <button key={opt.value} onClick={() => handelSorting(opt.value)} className={`text-left text-sm px-3 py-2 hover:bg-gray-100 ${sortingOrder === opt.value ? 'bg-gray-50' : ''}`}>{opt.label}</button>
                                ))}
                            </div>
                        }
                    >
                        <Button onClick={() => setIsSortingPopoverOpen(!isSortingPopoverOpen)} variant="outlined" className="flex items-center gap-2 bg-[#EBE9E6] border-none text-gray-800 capitalize">
                            <Bars3BottomLeftIcon className="h-4 w-4" />
                        </Button>
                    </Popover>

                    <Popover
                        isOpen={isFilterPopoverOpen}
                        positions={["bottom"]}
                        onClickOutside={() => setIsFilterPopoverOpen(false)}
                        content={
                            <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1 max-h-72 overflow-y-auto">
                                <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize" onClick={() => { setOrderTypeFilter(''); setIsFilterPopoverOpen(false); }}>{t('all_filter')}</button>
                                <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize" onClick={() => { setOrderTypeFilter('new_orders'); setIsFilterPopoverOpen(false); }}>{t('new_orders_label')}</button>
                                <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize" onClick={() => { setOrderTypeFilter('delayed_orders'); setIsFilterPopoverOpen(false); }} >{t('delayed_orders_label')}</button>
                                <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize" onClick={() => { setOrderTypeFilter('completed_orders'); setIsFilterPopoverOpen(false); }}>{t('completed_orders_label')}</button>
                                <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize" onClick={() => { setOrderTypeFilter('cancelled_orders'); setIsFilterPopoverOpen(false); }} >{t('cancelled_orders_label')}</button>

                                <hr className="my-1 border-gray-100" />
                                <p className="px-3 pt-1 pb-0.5 text-[10px] font-semibold text-gray-400 uppercase tracking-wide">
                                    {t('delivery_partner_payment_heading')}
                                </p>
                                <button disabled={isPaymentFilterDisabled}
                                    // className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize" 
                                    className={`text-left text-sm px-3 py-2 capitalize ${isPaymentFilterDisabled
                                        ? 'text-gray-300 cursor-not-allowed'
                                        : 'text-gray-700 hover:bg-gray-100'
                                        }`}
                                    onClick={() => { setOrderTypeFilter('payment_pending'); setIsFilterPopoverOpen(false); }}>{t('payment_pending_label')}</button>
                                <button disabled={isPaymentFilterDisabled}
                                    // className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize" 
                                    className={`text-left text-sm px-3 py-2 capitalize ${isPaymentFilterDisabled
                                        ? 'text-gray-300 cursor-not-allowed'
                                        : 'text-gray-700 hover:bg-gray-100'
                                        }`}
                                    onClick={() => { setOrderTypeFilter('partially_paid'); setIsFilterPopoverOpen(false); }}>{t('partially_paid_label')}</button>
                                <button disabled={isPaymentFilterDisabled}
                                    // className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize" 
                                    className={`text-left text-sm px-3 py-2 capitalize ${isPaymentFilterDisabled
                                        ? 'text-gray-300 cursor-not-allowed'
                                        : 'text-gray-700 hover:bg-gray-100'
                                        }`}
                                    onClick={() => { setOrderTypeFilter('fully_paid'); setIsFilterPopoverOpen(false); }}>{t('fully_paid_label')}</button>

                                <hr className="my-1 border-gray-100" />
                                <p className="px-3 pt-1 pb-0.5 text-[10px] font-semibold text-gray-400 uppercase tracking-wide">
                                    {t('purchase_status')}
                                </p>
                                <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize" onClick={() => { setOrderTypeFilter('purchased'); setIsFilterPopoverOpen(false); }}>{t('purchased')}</button>
                                <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize" onClick={() => { setOrderTypeFilter('purchase_pending'); setIsFilterPopoverOpen(false); }}>{t('purchase_pending')}</button>
                                <button className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize" onClick={() => { setOrderTypeFilter('partially_purchased'); setIsFilterPopoverOpen(false); }}>{t('partially_purchased')}</button>
                                <hr className="my-1 border-gray-100" />
                                <p className="px-3 pt-1 pb-0.5 text-[10px] font-semibold text-gray-400 uppercase tracking-wide">
                                    {t('order_stage_heading')}
                                </p>
                                {[
                                    { key: 'delivery_order_placed', label: t('order_placed_label') },
                                    { key: 'delivery_out_for_delivery', label: t('out_for_delivery_label') },
                                    { key: 'delivery_in_transit', label: t('in_transit_label') },
                                    { key: 'delivery_partial', label: t('partial_delivery_label') },
                                    { key: 'reassignment_required', label: t('reassignment_required_label') },
                                ].map((opt) => (
                                    <button
                                        key={opt.key}
                                        className={`text-left text-sm px-3 py-2 capitalize hover:bg-gray-100 ${orderTypeFilter === opt.key ? 'bg-gray-50 font-semibold text-black' : 'text-gray-700'}`}
                                        onClick={() => { setOrderTypeFilter(opt.key); setIsFilterPopoverOpen(false); }}
                                    >
                                        {opt.label}
                                    </button>
                                ))}
                                <hr className="my-1 border-gray-100" />
                                <p className="px-3 pt-1 pb-0.5 text-[10px] font-semibold text-gray-400 uppercase tracking-wide">
                                    {t('my_actions')}
                                </p>
                                <button
                                    className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize"
                                    onClick={() => { setOrderTypeFilter('pending_from_you'); setIsFilterPopoverOpen(false); }}
                                >
                                    {t('pending_from_you')}
                                </button>
                                <button
                                    className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize"
                                    onClick={() => { setOrderTypeFilter('done_from_you'); setIsFilterPopoverOpen(false); }}
                                >
                                    {t('done_from_you')}
                                </button>
                            </div>
                        }
                    >
                        <Button
                            onClick={() => setIsFilterPopoverOpen(!isFilterPopoverOpen)}
                            variant="outlined"
                            className="flex items-center gap-2 border-gray-300 capitalize"
                        >
                            <FunnelIcon className="h-4 w-4" />
                            {t('filter_button')} {orderTypeFilter ? `(${orderTypeFilter.replace(/_/g, ' ')})` : ''}
                        </Button>
                    </Popover>

                    {/* {hasDeletePermission && (
                        <Popover
                            isOpen={isCheckedItemPopoverOpen}
                            positions={["bottom"]}
                            onClickOutside={() => setIsCheckedItemPopoverOpen(false)}
                            content={
                                <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">
                                    {action_options.map((opt) => (
                                        <button key={opt.value} onClick={() => handelCheckedItems(opt.value)} className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize">{opt.label}</button>
                                    ))}
                                </div>
                            }
                        >
                            <Button
                                onClick={() => setIsCheckedItemPopoverOpen(!isCheckedItemPopoverOpen)}
                                variant="outlined"
                                className="flex items-center gap-2 bg-black text-white capitalize"
                                disabled={checkedItems.length === 0}
                            >
                                Selected Items ({checkedItems.length}) <ChevronDownIcon className="h-4 w-4" />
                            </Button>
                        </Popover>
                    )} */}

                    {hasDeletePermission && (
                        <Popover
                            isOpen={isCheckedItemPopoverOpen}
                            positions={["bottom"]}
                            onClickOutside={() => setIsCheckedItemPopoverOpen(false)}
                            content={
                                <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">
                                    {action_options.map((opt) => (
                                        <button
                                            key={opt.value}
                                            onClick={() => {
                                                if (!opt.disabled) {
                                                    handelCheckedItems(opt.value);
                                                }
                                            }}
                                            disabled={opt.disabled}
                                            className={`text-left text-sm px-3 py-2 capitalize transition-colors ${opt.disabled
                                                ? "text-gray-400 bg-gray-50/50 cursor-not-allowed select-none"
                                                : "text-gray-700 hover:bg-gray-100"
                                                }`}
                                        >
                                            {opt.label}
                                        </button>
                                    ))}
                                </div>
                            }
                        >
                            <Button
                                onClick={() => setIsCheckedItemPopoverOpen(!isCheckedItemPopoverOpen)}
                                variant="outlined"
                                className="flex items-center gap-2 bg-black text-white capitalize"
                                disabled={checkedItems.length === 0}
                            >
                                {t('selected_items_button')} ({checkedItems.length}) <ChevronDownIcon className="h-4 w-4" />
                            </Button>
                        </Popover>
                    )}
                </div>
            </div>

            {/* Sub-tabs (Unassigned / Pending / Assigned) */}
            <div className="flex gap-4 md:gap-8 border-b border-gray-100 px-4 md:px-6 pt-2 overflow-x-auto">
                {tabs.map((t) => (
                    <button
                        key={t.id}
                        onClick={() => setFilter(t.id)}
                        className={`relative pb-2 text-sm md:text-base font-medium transition-all whitespace-nowrap ${filter === t.id ? "border-b-2 border-black text-black" : "text-gray-500 hover:text-gray-700"}`}
                    >
                        {t.label} {(total_count && total_count[t.id]) ? `(${total_count[t.id]})` : '(0)'}
                        {unread_counts?.[t.id] > 0 && (
                            <span className="absolute top-0 -right-2.5 flex h-2 w-2">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                            </span>
                        )}
                    </button>
                ))}
            </div>

            {/* Data List Container */}
            <div className="px-4 md:px-6">
                {list_loading && currentPage === 1 && list_orders?.length === 0 ? (
                    <div className="flex justify-center items-center py-20">
                        <ShowLoader />
                    </div>
                ) : list_orders?.length === 0 && !list_loading ? (
                    <div className="flex flex-col items-center justify-center py-20 min-h-[400px]">
                        <svg className="w-16 h-16 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <p className="text-center text-gray-400 text-base font-medium">{t("noOrdersFound")}</p>
                        <p className="text-center text-gray-400 text-sm mt-2">{t("tryAdjustingFilters")}</p>
                    </div>
                ) : (
                    <div id="scrollableDiv" className="divide-y divide-gray-100 h-[calc(100vh-350px)] min-h-[400px] overflow-y-auto overflow-x-auto">
                        <InfiniteScroll
                            dataLength={list_orders?.length || 0}
                            next={fetchMoreData}
                            hasMore={hasMore}
                            scrollableTarget="scrollableDiv"
                            loader={
                                <div className="flex justify-center items-center py-4">
                                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-900"></div>
                                    <span className="ml-2 text-gray-600 text-sm">{t('loading_more')}</span>
                                </div>
                            }
                        // endMessage={
                        //     list_orders?.length > 0 ? (
                        //         <div className="text-center py-6">
                        //             <p className="text-gray-400 text-sm">No more orders to load.</p>
                        //         </div>
                        //     ) : null
                        // }
                        >
                            {list_orders?.length > 0 && list_orders?.map((order) => {
                                const totalPrice = order?.products?.reduce((sum, item) => sum + (item?.customer_price ? Number(item.customer_price) : Number(item.total_amount) || 0), 0);
                                const formattedPrice = totalPrice ? totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';

                                const isFinanceManagerUser = user?.roles?.[0] === "Finance" && (user?.parent_id == null || user?.designation?.toLowerCase() === "manager");
                                const hasFinanceMemberAssigned = order?.assigned_details?.some(d => d.role === "Finance" && d.designation?.toLowerCase() === "member");
                                const canManagerAct = !hasFinanceMemberAssigned || order?.finance_manager_status === 'approved';

                                // || order?.finance_manager_status === 'pending'

                                return (
                                    <div key={order.id} className="grid grid-cols-6 w-full min-w-[1100px] items-start gap-4 pt-7 pb-5 hover:bg-gray-50 transition-colors border-b border-[#DBDBDB]">
                                        {/* ID & Checkbox */}
                                        <div className="flex items-start gap-3">
                                            {hasDeletePermission && (
                                                <input type="checkbox" className="w-4 h-4 accent-green cursor-pointer mt-1" onChange={() => handleSingleCheck(order.id)} checked={checkedItems.includes(order.id)} />
                                            )}
                                            <div className="flex flex-col gap-1">
                                                {(() => {
                                                    const isFinance = user?.roles[0] === 'Finance';
                                                    const isPending = filter === 'pending_for_approval';
                                                    const role = user?.roles?.[0];

                                                    const shouldDisable =
                                                        isPending &&
                                                        !["Finance", "Administrator", "Sub Admin"].includes(role);

                                                    const newDot = order?.is_new && (
                                                        <span className="relative flex h-2 w-2">
                                                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                                            <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                                                        </span>
                                                    );

                                                    if (shouldDisable) {
                                                        return (
                                                            <div className="flex items-center gap-1.5">
                                                                <span className="font-bold text-sm text-[#1A1918]">
                                                                    {t('po_id_label')}: {order.order_id}
                                                                </span>
                                                                {newDot}
                                                            </div>
                                                        );
                                                    }

                                                    return (
                                                        <div className="flex items-center gap-1.5">
                                                            <Link
                                                                to={`/dashboard/orders/${order.id}?rfq_id=${order?.rfq_id}`}
                                                                state={{ from: searchParams.toString() }}
                                                                className="font-bold text-sm text-[#1A1918] hover:text-blue-600 hover:underline cursor-pointer transition"
                                                            >
                                                                {t('po_id_label')}: {order.order_id}
                                                            </Link>
                                                            {newDot}
                                                        </div>
                                                    );
                                                })()}
                                                <p className="text-sm text-gray-500 font-medium flex items-center gap-2 capitalize">
                                                    <span>{t('po_label')}: {order.purchase_order_number}</span>

                                                    {order?.purchase_order_file && (
                                                        <DocumentArrowDownIcon
                                                            className="h-4 w-4 text-gray-500 cursor-pointer hover:text-blue-600"
                                                            onClick={() => setPOFile(order.purchase_order_file)}
                                                        />
                                                    )}
                                                </p>
                                                <p className="text-sm text-gray-500 font-medium flex items-center gap-2 capitalize">
                                                    <span>{t('rfq_id_label')}: {order?.rfq?.id || 'N/A'}</span>
                                                </p>
                                                <p className="text-sm text-gray-500 font-medium flex items-center gap-2 capitalize">
                                                    <span>{t('cs_rfq_ref_id_label')}: {order?.rfq?.rfq_reference}</span>
                                                </p>
                                                {/* {order?.purchase_status?.label && ( */}
                                                {order?.purchase_status?.label && !(hidePurchasePending && order.purchase_status.status === 'purchase_pending') && (
                                                    <span
                                                        className={`w-fit text-[10px] px-2 py-0.5 rounded-full font-bold
                                                        ${order.purchase_status.status === 'purchased'
                                                                ? "bg-green-100 text-green-700"
                                                                : order.purchase_status.status === 'partially_purchased'
                                                                    ? "bg-yellow-100 text-yellow-700"
                                                                    : "bg-red-100 text-red-700"
                                                            }`}
                                                    >
                                                        {t(order.purchase_status.status)}
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        {/* Customer Info */}
                                        <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-1">
                                                <p className="font-bold text-sm text-[#1A1918]">{order?.customer?.company_name}</p>
                                                {order?.alternate_number && (
                                                    <Tooltip content={`${t('alt_phone_tooltip')} ${order.alternate_number}`} className="bg-white text-gray-900 border border-gray-200 shadow-md">
                                                        <InformationCircleIcon className="h-4 w-4 text-gray-400 cursor-pointer" />
                                                    </Tooltip>
                                                )}
                                            </div>
                                            <p className="text-sm font-medium text-gray-500 m-0">{order?.customer?.country_code} {order?.customer?.mobile_number}</p>

                                            {user?.roles[0] === 'Finance' && <>
                                                <div className="flex items-center gap-1">
                                                    <p className="font-bold text-sm text-[#1A1918]">{t('due_payment_label')}</p>
                                                </div>
                                                <p className="text-sm font-medium text-gray-500 m-0">SAR {order?.payment_summary?.due_amount ?? 0}</p>
                                            </>
                                            }

                                        </div>

                                        {/* Items & Location */}
                                        <div className="flex flex-col gap-1">
                                            <p className="font-bold text-sm text-[#1A1918]">Items: {order?.products?.length || 0}</p>
                                            <p className="text-sm font-medium text-gray-500 truncate">{t('deliver_to_label')} {order?.customer?.kyc_details?.permanent_address || 'N/A'}</p>
                                            {user?.roles[0] === 'Finance' && <>
                                                <div className="flex items-center gap-1">
                                                    <p className="font-bold text-sm text-[#1A1918]">{t('amount_received_label')}</p>
                                                </div>
                                                <p className="text-sm font-medium text-gray-500 m-0">SAR {order?.payment_summary?.paid_amount ?? 0}</p>
                                            </>
                                            }

                                        </div>

                                        {/* Pricing & Deadline */}
                                        <div className="flex flex-col gap-1">
                                            {(() => {
                                                const currencyCode =
                                                    order?.payment_summary?.currency_code ||
                                                    order?.products?.[0]?.rfq_currency_code ||
                                                    'SAR';

                                                return (
                                                    <>
                                                        <p className="text-[#1A1918] font-bold">
                                                            {currencyCode} {order?.payment_summary?.grand_total ?? 0}
                                                        </p>

                                                        {(user?.roles[0] === 'Sub Admin' || user?.roles[0] === 'Administrator' || user?.roles[0] === 'Finance') && (
                                                            <p className="text-sm font-medium text-gray-500">
                                                                {t('deadline_label')} {order?.assigned_details?.[0]?.deadline ? moment.utc(order.assigned_details[0].deadline).format("D MMM | hh:mm A") : "N/A"}
                                                            </p>
                                                        )}

                                                        {user?.roles[0] !== 'Sub Admin' && user?.roles[0] !== 'Administrator' && user?.roles[0] !== 'Finance' && (
                                                            (() => {
                                                                const assigned_user = order?.assigned_details?.find((item) => item.assigned_to_id === user?.id) ||
                                                                    order?.assigned_details?.[0];

                                                                const timeSlotTo = assigned_user?.timeslot?.to;
                                                                const status = getTimeSlotStatus(timeSlotTo);
                                                                return (
                                                                    <p className={`text-sm font-medium ${status.color}`}>
                                                                        {t('timeslot_label')} {assigned_user?.timeslot?.from ?
                                                                            moment(assigned_user.timeslot.from).format("D MMM | hh:mm A") + " - " + moment(timeSlotTo).format("D MMM | hh:mm A")
                                                                            : "N/A"
                                                                        }
                                                                        {status.delayed}
                                                                    </p>
                                                                );
                                                            })()
                                                        )}

                                                        {user?.roles[0] === 'Finance' && (
                                                            <>
                                                                <div className="flex items-center gap-1">
                                                                    <p className="font-bold text-sm text-[#1A1918]">{t('last_amount_label')}</p>
                                                                </div>
                                                                <p className="text-sm font-medium text-gray-500 m-0">
                                                                    {currencyCode} {order?.payment_summary?.last_paid_amount ?? 0}{" "}
                                                                    {order?.payment_summary?.updated_at
                                                                        ? "Received On: " + order.payment_summary.updated_at
                                                                        : ""}
                                                                </p>
                                                            </>
                                                        )}
                                                    </>
                                                );
                                            })()}
                                        </div>

                                        {/* Actions Icons */}
                                        <div className="flex flex-col gap-2 items-center justify-center">
                                            <div className="flex gap-2 justify-center items-center">
                                                {(() => {
                                                    const isFinance = user?.roles[0] === 'Finance';
                                                    const isPending = filter === 'pending_for_approval';

                                                    const shouldHide = isPending && !isFinance;

                                                    if (shouldHide) return null;

                                                    return (
                                                        <>
                                                            {/* Timeline Icon */}
                                                            <Tooltip content={t('timeline_tooltip')}>
                                                                <ClockIcon className="w-4 h-4 text-gray-500 cursor-pointer hover:text-black" onClick={() => setIsTimelineModalOpen(order.id)} />
                                                            </Tooltip>

                                                            {/* Chat Icon */}
                                                            <Tooltip content={t('chat_tooltip')}>
                                                                <Link to={`/dashboard/orders/${order.id}`} state={{ active_tab: 'chat' }}>
                                                                    <ChatBubbleOvalLeftEllipsisIcon className="w-4 h-4 text-gray-500 hover:text-blue-500" />
                                                                </Link>
                                                            </Tooltip>
                                                        </>
                                                    );
                                                })()}
                                                {/* Remark/Notes Popover */}
                                                {order?.assigned_details?.some(d => d.notes && d.assigned_to?.id === user?.id) && (
                                                    <Popover
                                                        isOpen={openRemarkId === order.id}
                                                        positions={["left", "bottom", "top"]}
                                                        padding={10}
                                                        onClickOutside={() => setOpenRemarkId(null)}
                                                        containerStyle={{ zIndex: '9999' }}
                                                        content={
                                                            <div className="bg-white shadow-2xl rounded-lg w-72 border border-gray-200 overflow-hidden">
                                                                <div className="bg-gray-50 px-3 py-2 border-b border-gray-200 flex justify-between items-center">
                                                                    <Typography className="font-bold text-xs text-gray-700">{t('your_remarks_label')}</Typography>
                                                                    <XCircleIcon className="h-4 w-4 text-gray-400 cursor-pointer" onClick={() => setOpenRemarkId(null)} />
                                                                </div>
                                                                <div className="max-h-48 overflow-y-auto p-3 flex flex-col gap-3">
                                                                    {/* Filtered mapping: Only show notes where assigned_to.id matches logged-in user.id */}
                                                                    {order.assigned_details
                                                                        .filter(detail => detail.notes && detail.assigned_to?.id === user?.id)
                                                                        .map((detail, idx) => (
                                                                            <div key={idx} className="flex flex-col gap-1 border-b border-gray-50 last:border-none pb-2">
                                                                                <div className="flex items-center gap-2">
                                                                                    <span className="text-[10px] font-bold text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded">
                                                                                        {detail.assigned_to?.name} (You)
                                                                                    </span>
                                                                                    <span className="text-[9px] text-gray-400">
                                                                                        {detail.assigned_at ? moment(detail.assigned_at).format("DD MMM | h:mm A") : ""}
                                                                                    </span>
                                                                                </div>
                                                                                <p className="text-[12px] text-gray-600 leading-snug break-words italic">
                                                                                    "{detail.notes}"
                                                                                </p>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                    >
                                                        <div
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                setOpenRemarkId(openRemarkId === order.id ? null : order.id);
                                                            }}
                                                        >
                                                            <Tooltip content={t('your_remarks_label')}>
                                                                <InformationCircleIcon
                                                                    className={`w-4 h-4 cursor-pointer transition-colors ${openRemarkId === order.id ? "text-blue-600" : "text-gray-500 hover:text-blue-600"}`}
                                                                />
                                                            </Tooltip>
                                                        </div>
                                                    </Popover>
                                                )}
                                            </div>

                                            {/* Status Badges */}
                                            {filter === "assigned" && order?.delivery_status != 'cancelled' && (
                                                <span
                                                    className={`w-20 text-[10px] px-2 py-0.5 rounded-full text-center font-bold
                                                    ${order?.city_representative_approval?.trim() === "yes"
                                                            ? "bg-green-100 text-green-700"
                                                            : order?.city_representative_approval?.trim() === "no"
                                                                ? "bg-red-100 text-red-700"
                                                                : order?.is_send_to_city_rep !== null ? "bg-yellow-100 text-yellow-700" : ''
                                                        }`}
                                                >
                                                    {order?.city_representative_approval?.trim() === "yes"
                                                        ? t('approved_status')
                                                        : order?.city_representative_approval?.trim() === "no"
                                                            ? t('rejected_status')
                                                            : order?.is_send_to_city_rep !== null ? t('pending_status') : ''}
                                                </span>
                                            )}
                                            {/* Workflow Message */}
                                            {order?.workflow_status?.status && (
                                                <div
                                                    className="text-[12px] px-2 py-1 rounded-full font-semibold text-center max-w-[200px]"
                                                    style={{
                                                        backgroundColor: order.workflow_status.colors?.background,
                                                        color: order.workflow_status.colors?.text,
                                                    }}
                                                >
                                                    {order.workflow_status.status}
                                                </div>
                                            )}
                                        </div>

                                        {/* Dynamic CTA Button */}
                                        <div className="flex flex-col items-center justify-start right-0 z-20 bg-[#F5F7F8] min-h-[80px] px-2 py-2 shadow-[-8px_0_8px_-6px_rgba(0,0,0,0.1)]">
                                            {(user.roles[0] !== 'Finance' && filter === 'unassigned' && hasUpdatePermission && order?.delivery_status !== 'cancelled') ? (
                                                <button
                                                    onClick={() => {
                                                        if (order?.customer_approval === 'yes') {
                                                            Toaster.error(t('quotation_already_approved_error'));
                                                        } else {
                                                            setIsAssignModalOpen(order.id)
                                                        }
                                                    }}
                                                    className="bg-[#F4B320] hover:bg-yellow-500 text-[#1A1918] font-normal px-4 py-1.5 rounded-lg transition whitespace-nowrap"
                                                >
                                                    {t('approve_and_assign_button')}
                                                </button>
                                            ) : (
                                                <div className="flex -space-x-2 justify-center"
                                                    onClick={() => {
                                                        setSelectedOrder(order);
                                                        setIsMemberShow(true);
                                                    }}>
                                                    {order?.assigned_details?.filter(r => r.type !== "customer").map((row, i) => (
                                                        <Tooltip key={i} content={row.assigned_to?.name}>
                                                            <img
                                                                className="w-7 h-7 rounded-full border-2 border-white object-cover"
                                                                src={row.assigned_to?.profile_image || '/img/default-avatar-profile-icon.avif'}
                                                                alt={row.assigned_to?.name || 'User'}
                                                                onError={(e) => {
                                                                    e.target.src = '/img/default-avatar-profile-icon.avif';
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    ))}
                                                </div>

                                            )}
                                            {((user.roles[0] === 'Administrator') || (isFinanceManagerUser && canManagerAct)) &&
                                                filter === 'pending_for_approval' &&
                                                hasUpdatePermission && (
                                                    <button
                                                        onClick={() => financeApproveOrder(order.id)}
                                                        className="bg-[#F4B320] hover:bg-yellow-500 text-[#1A1918] font-normal px-4 py-1.5 rounded-lg transition whitespace-nowrap"
                                                    >
                                                        {t('approve_reject_button')}
                                                    </button>
                                                )}
                                            {(user.roles[0] === 'Administrator' || user.roles[0] === 'Sub Admin') &&
                                                filter === 'payment_issue' &&
                                                hasUpdatePermission && (
                                                    <button
                                                        onClick={() => resendToFinance(order.id)}
                                                        className="bg-[#F4B320] hover:bg-yellow-500 text-[#1A1918] font-normal px-4 py-1.5 rounded-lg transition whitespace-nowrap"
                                                    >
                                                        Resend to Finance
                                                    </button>
                                                )}
                                            {order?.order_status === 'cancellation_requested' && filter === 'cancelled' &&
                                                <button
                                                    onClick={() => handleCancellationAction(order.id)}
                                                    className="bg-[#F4B320] hover:bg-yellow-500 text-[#1A1918] font-normal px-4 py-1.5 rounded-lg transition whitespace-nowrap"
                                                >
                                                    {t('approve_reject_button')}
                                                </button>
                                            }
                                            <p className="text-gray-500 text-[12px] leading-tight mt-2 text-center">{formatReceivedOrderDate(order.created_at)}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </InfiniteScroll>
                    </div>
                )}
            </div>

            {/* Modals */}
            {isAssignModalOpen && (
                <AssignCRManagerModal
                    onClose={() => {
                        setIsAssignModalOpen(false);
                        loadData(1);
                        dispatch(setEmptyCRTeamMember())
                    }}
                    orderId={isAssignModalOpen}
                />
            )}
            {isTimelineModalOpen && (
                <TimeLineModal
                    isOpen={!!isTimelineModalOpen}
                    onClose={() => setIsTimelineModalOpen(false)}
                    orderId={isTimelineModalOpen}
                />
            )}
            {isSetPOFile && <DocumentViewModal documentUrl={isSetPOFile} setIsDocumentViewModalOpen={setPOFile}></DocumentViewModal>}

            {isMemberShow && selectedOrder && (
                <ViewAssignedMembers
                    onClose={() => {
                        setIsMemberShow(false);
                        setSelectedOrder(null);
                    }}
                    rfq_id={selectedOrder?.rfq_id}
                    order_id={selectedOrder?.id}
                />
            )}

        </div>
    );
}

export default Order;